import { inject, Injectable } from '@angular/core';
import { catchError, map } from 'rxjs';
import { handleError } from '../tools/handle-error.tools';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '@/environments/environment';
import { AreaResponsable } from '@/app/models/interface/area-responsable.model';
import {
  PaginatorModel,
  HasPagination,
} from '@/app/models/interface/paginator.model';
import { CustomResponse } from '@/app/models/interface/response.model';
import { UsuarioResponsable } from '@/app/models/interface/usuario-responsable';

@Injectable({ providedIn: 'root' })
export class AreaResponsableService {
  private readonly http = inject(HttpClient);
  private readonly url = environment.api + 'area-responsable/';

  create(data: Partial<AreaResponsable>) {
    return this.http.post<CustomResponse<AreaResponsable>>(this.url, data).pipe(
      catchError((err) => handleError(err)),
      map((data) => {
        const d = data.result;
        return {
          ...d,
        };
      }),
    );
  }

  findAll(params?: HttpParams) {
    return this.http
      .get<CustomResponse<PaginatorModel<AreaResponsable[], HasPagination>>>(
        this.url,
        {
          params,
        },
      )
      .pipe(
        catchError((err) => handleError(err)),
        map((data) => {
          const d = data.result;
          if (d && Array.isArray(d.data)) {
            return {
              ...d,
              data: d.data.map((d) => ({
                ...d,
              })),
            };
          }
          return d;
        }),
      );
  }

  findOne(id: number) {
    const url = this.url + id;
    return this.http.get<CustomResponse<AreaResponsable>>(url).pipe(
      catchError((err) => handleError(err)),
      map((data) => {
        const d = data.result;
        return {
          ...d,
        };
      }),
    );
  }

  update(tipo: Partial<AreaResponsable>) {
    const url = this.url + tipo.id;
    return this.http.put<CustomResponse<AreaResponsable>>(url, tipo).pipe(
      catchError((err) => handleError(err)),
      map((data) => {
        const d = data.result;
        return {
          ...d,
        };
      }),
    );
  }

  changeState(state: boolean, id: number) {
    const url = this.url + id;
    return this.http
      .patch<CustomResponse<AreaResponsable>>(url, { state })
      .pipe(
        catchError((err) => handleError(err)),
        map((data) => {
          const d = data.result;
          return {
            ...d,
          };
        }),
      );
  }

  getUsuariosResponsables(params: HttpParams) {
    const url = this.url + 'getResponsables';

    return this.http
      .get<CustomResponse<UsuarioResponsable[] | null>>(url, { params })
      .pipe(
        catchError((err) => handleError(err)),
        map((data) => data.result),
      );
  }
}
